import { Grid, styled } from "@mui/material";
import get from "lodash/get";
import React from "react";
import BSInput from "../../../common/js/components/BSInput";

const StyledField = styled(Grid)(() => ({
    width: "100%",
    height: "84px",
    margin: "0px",
}));

const LocationFilters = (props) => {
    const { hideFilters, onKeyPress, searchCriteria, updateFilter } = props;

    return (
        <React.Fragment>
            <StyledField container justifyContent="space-between" spacing={16}>
                <BSInput
                    label="City"
                    placeholder="Cities (separated by comma(,))"
                    value={get(searchCriteria, "locationCriteria.cities", "")}
                    onChange={(e) => updateFilter("locationCriteria.cities", e.target.value)}
                    onKeyPress={onKeyPress}
                />
            </StyledField>

            <StyledField container justifyContent="space-between" spacing={16}>
                <BSInput
                    label="State"
                    placeholder="States (separated by comma(,))"
                    value={get(searchCriteria, "locationCriteria.states", "")}
                    onChange={(e) => updateFilter("locationCriteria.states", e.target.value)}
                    onKeyPress={onKeyPress}
                />
            </StyledField>
            <StyledField container justifyContent="space-between" spacing={16}>
                <BSInput
                    label={"Zip Code"}
                    placeholder="Zip Codes (separated by comma(,))"
                    value={get(searchCriteria, "locationCriteria.zips", "")}
                    onChange={(e) => updateFilter("locationCriteria.zips", e.target.value)}
                    onKeyPress={onKeyPress}
                />
            </StyledField>
            <StyledField container justifyContent="space-between" spacing={8}>
                <BSInput
                    label={"County"}
                    placeholder="Counties (separated by comma(,))"
                    value={get(searchCriteria, "locationCriteria.counties", "")}
                    onChange={(e) => updateFilter("locationCriteria.counties", e.target.value)}
                    onKeyPress={onKeyPress}
                />
            </StyledField>
            {!hideFilters && (
                <StyledField container justifyContent="space-between" spacing={8}>
                    <BSInput
                        label={"True Client Name"}
                        placeholder="True Client Name"
                        value={get(searchCriteria, "clientName", "")}
                        onChange={(e) => updateFilter("clientName", e.target.value)}
                        onKeyPress={onKeyPress}
                    />
                </StyledField>
            )}
            <StyledField container justifyContent="space-between" spacing={8}>
                <BSInput
                    label={"Building Name"}
                    placeholder="Building Name"
                    value={get(searchCriteria, "buildingName", "")}
                    onChange={(e) => updateFilter("buildingName", e.target.value)}
                    onKeyPress={onKeyPress}
                />
            </StyledField>
        </React.Fragment>
    );
};

export default LocationFilters;
